// extracted by mini-css-extract-plugin
export var board = "DemoSection-module--board--8916b";
export var boardThreePanels = "DemoSection-module--boardThreePanels--b5066";
export var divider = "DemoSection-module--divider--f253e";
export var footer = "DemoSection-module--footer--3a348";
export var footerBackgroundImage = "DemoSection-module--footerBackgroundImage--98ab2";
export var footerBackgroundSection = "DemoSection-module--footerBackgroundSection--2ba45";